var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-user-item-container"},_vm._l((_vm.krugIdText),function(n,i){return _c('span',{key:i},[(i % 2)?_c('mark',[_vm._v(_vm._s(n))]):_c('span',[_vm._v(_vm._s(n))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }